const calculateIEM = (TEA, payPeriod) => {
  const iem = (1 + TEA) ** (1 / payPeriod) - 1;
  return iem;
};
// Interes
const calculatInterest = (averageAmount, TEA, payPeriod) => {
  const iem = calculateIEM(TEA, payPeriod);
  const interest = Math.round(iem * averageAmount);
  return interest;
};

const calculatRetefuente = (data = []) => {
  const retefuenteValue = 0.04;
  const reteFuente = [];
  data?.map((i) => reteFuente.push({
    ...i,
    reteFuente: i.graciaTime ? 0 : Math.round(retefuenteValue * i.interest),
  }));

  return reteFuente;
};

// Periodo de gracia
const calculateGracePeriod = (
  graciaTime,
  numberGracePeriod,
  payPeriod,
  interest,
) => {
  const gracePeriod = graciaTime
    ? 0
    : Math.round((interest * numberGracePeriod) / payPeriod);
  return gracePeriod;
};
// Total cuota
const calculateTotalQuota = (data = [], numberGracePeriod, payPeriod) => {
  const paymentTotalQuota = [];
  data?.map((i) => {
    const gracePeriod = calculateGracePeriod(
      i.graciaTime,
      numberGracePeriod,
      payPeriod,
      i.interest,
    );
    const totalQuota = i.graciaTime
      ? 0
      : Math.round(gracePeriod + i.interest + i.paymentToCapital);
    return paymentTotalQuota.push({
      ...i,
      totalQuota,
      gracePeriod,
    });
  });

  return paymentTotalQuota;
};

const calculatePaymentToCapital = (
  data = [],
  averageAmount,
  TEA,
  payPeriod,
) => {
  const paymentToCapital = [];

  data?.map((i) => {
    const interest = calculatInterest(averageAmount, TEA, payPeriod);
    return paymentToCapital.push({
      ...i,
      paymentToCapital: i.fixedFee > 0 ? i.fixedFee : 0,
      interest,
    });
  });

  return paymentToCapital;
};

// Cuota Bloom plataforma
const calculateTotalQuotaBloom = (
  numberGracePeriod,
  payPeriod,
  averageAmount,
  TEA,
) => {
  const graciaTime = () => {
    const results = [];
    for (let i = 0; i < payPeriod + numberGracePeriod; i += 1) {
      if (i > numberGracePeriod) {
        results.push({ graciaTime: false, fixedFee: 0 });
      }
      if (i === payPeriod + numberGracePeriod - 1) {
        results.push({ graciaTime: false, fixedFee: Number(averageAmount) });
      }
      if (i < numberGracePeriod) {
        results.push({ graciaTime: true, fixedFee: 0 });
      }
    }
    return results;
  };
  const dataGraciaTime = graciaTime();
  const paymentToCapital = calculatePaymentToCapital(
    dataGraciaTime,
    averageAmount,
    TEA,
    payPeriod,
  );

  const totalQuota = calculateTotalQuota(
    paymentToCapital,
    numberGracePeriod,
    payPeriod,
  );

  const reteFuente = calculatRetefuente(totalQuota);
  const totalQuotaBloom = [];
  reteFuente.map((i, index) => totalQuotaBloom.push({
    ...i,
    cuota: index + 1,
    totalQuotaBloom: i.graciaTime
      ? 0
      : Math.round(i.interest + i.paymentToCapital),
  }));

  const simulatorInfo = () => {
    const total = totalQuotaBloom.reduce(
      (i, t) => i + (t.paymentToCapital + t.interest - t.reteFuente),
      0,
    );
    const amountInteres = totalQuotaBloom.reduce((i, t) => i + +t.interest, 0);
    const response = {
      total,
      amountInteres,
      totalQuotaBloom: totalQuotaBloom[numberGracePeriod].totalQuotaBloom,
      lastQuota:
        totalQuotaBloom[totalQuotaBloom.length - 1].totalQuotaBloom
        - totalQuotaBloom[totalQuotaBloom.length - 1].reteFuente,
    };
    return response;
  };

  return { allQuotas: totalQuotaBloom, simulatorInfo: simulatorInfo() };
};

export default calculateTotalQuotaBloom;
